/**
 * Bandiere come SVG, non emoji: il brand vieta emoji ovunque (BRAND.md) e il
 * rendering dei flag-emoji è incoerente tra sistemi (alcuni mostrano solo
 * il codice lettere). Minimali, leggibili anche a 18-20px.
 */
export function FlagIcon({ country, className }: { country: "it" | "gb"; className?: string }) {
  if (country === "it") {
    return (
      <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
        <rect width="20" height="30" fill="#009246" />
        <rect x="20" width="20" height="30" fill="#F1F2F1" />
        <rect x="40" width="20" height="30" fill="#CE2B37" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
      <rect width="60" height="30" fill="#00247D" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#CF142B" strokeWidth="2" />
      <path d="M30,0 V30 M0,15 H60" stroke="#FFFFFF" strokeWidth="10" />
      <path d="M30,0 V30 M0,15 H60" stroke="#CF142B" strokeWidth="6" />
    </svg>
  );
}
